var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockOfferBanner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5005 78.1397C56.6592 78.1397 73.001 61.7979 73.001 41.6392C73.001 21.4805 56.6592 5.13867 36.5005 5.13867C16.3418 5.13867 0 21.4805 0 41.6392C0 61.7979 16.3418 78.1397 36.5005 78.1397Z",
    fill: "#C5D9FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6027 42.5108H45.3172V35.8556C45.3172 30.9938 41.3624 27.0374 36.4991 27.0374C31.6358 27.0374 27.681 30.9923 27.681 35.8556V54.4091H19.3955V35.8556C19.3955 26.4249 27.0685 18.752 36.4991 18.752C45.9298 18.752 53.6027 26.4249 53.6027 35.8556V42.5108Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1373 48.6387H14.8634C11.9005 48.6387 9.49854 51.0406 9.49854 54.0035V78.6351C9.49854 81.598 11.9005 83.9999 14.8634 83.9999H58.1373C61.1002 83.9999 63.5021 81.598 63.5021 78.6351V54.0035C63.5021 51.0406 61.1002 48.6387 58.1373 48.6387Z",
    fill: "url(#paint0_linear_2086_60104)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2951 67.7899C40.6445 66.8874 41.5352 65.3487 41.5352 63.6013C41.5352 60.8198 39.2803 58.5664 36.5002 58.5664C33.7202 58.5664 31.4653 60.8212 31.4653 63.6013C31.4653 65.3472 32.3545 66.8859 33.7054 67.7899L31.668 71.8468C31.1561 72.8677 31.8974 74.0706 33.0396 74.0706H39.9624C41.1046 74.0706 41.8473 72.8677 41.3339 71.8468L39.2966 67.7899H39.2951Z",
    fill: "#072F73"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.69627 18.7866C8.84223 18.7866 11.3925 16.2363 11.3925 13.0903C11.3925 9.94435 8.84223 7.39404 5.69627 7.39404C2.55031 7.39404 0 9.94435 0 13.0903C0 16.2363 2.55031 18.7866 5.69627 18.7866Z",
    fill: "#072F73"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3247 27.5377L77.7521 22.3241C80.8455 20.7834 83.1497 25.4549 80.0839 26.988L69.6566 32.2016C66.56 33.7395 64.2575 29.0715 67.3247 27.5377Z",
    fill: "#0096FA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7522 58.2698L67.3248 53.056C64.2566 51.5219 66.5596 46.8528 69.6566 48.3921L80.084 53.6057C83.1299 55.1289 80.8807 59.8235 77.7522 58.2698Z",
    fill: "#0096FA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9186 42.904H68.4912C65.0549 42.904 65.0408 37.6904 68.4912 37.6904H78.9186C82.355 37.6903 82.369 42.904 78.9186 42.904Z",
    fill: "#0096FA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2086_60104",
    x1: 19.4677,
    y1: 39.5883,
    x2: 58.1447,
    y2: 100.288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0096FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#0390F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#0B80F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1968F0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockOfferBanner);
export default __webpack_public_path__ + "static/media/LockOfferBanner.e6ab1fea6c67112450eb4d4bdc719ff6.svg";
export { ForwardRef as ReactComponent };